import {GLOBAL} from '../deprecated/global';
import {addOrderNotesToAdditionalFields, collectAdditionalFieldData} from '../features/additionalFields';
import {DispatchActionType} from '../models/DispatchActionType';
import {type IPeachPayOrder} from '../models/IPeachPayOrder';
import {type DispatchAction, store} from '../store';
import {cleanFormFields} from '../util/form';
import {createDispatchUpdate} from './initialState';
import {PeachPayCustomer} from './peachPayCustomerReducer';

export function peachPayOrderReducer(state: IPeachPayOrder, action: DispatchAction<unknown>): IPeachPayOrder {
	switch (action.type) {
		case DispatchActionType.ORDER_SESSION_ID:
			return {
				...state,
				sessionId: (action as DispatchAction<string>).payload,
			};
		case DispatchActionType.ORDER_ADDRESS_VALIDATED:
			return {
				...state,
				customerAddressValidated: (action as DispatchAction<boolean>).payload,
			};
		case DispatchActionType.ORDER_SET_EXTRA_FIELDS:
			return {
				...state,
				additionalFields: {
					...(action as DispatchAction<Record<string, string>>).payload,
				},
			};
		case DispatchActionType.ORDER_SET_ERROR_MESSAGE:
			return {
				...state,
				errorMessage: (action as DispatchAction<string>).payload,
			};
		default:
			return {
				...state,
			};
	}
}

// ============================== Action Creators =================================

export const setSessionId = createDispatchUpdate<string>(DispatchActionType.ORDER_SESSION_ID);
export const updateCustomerAddressValidation = createDispatchUpdate<boolean>(DispatchActionType.ORDER_ADDRESS_VALIDATED);
export const setExtraFields = createDispatchUpdate<Record<string, string>>(DispatchActionType.ORDER_SET_EXTRA_FIELDS);
export const setOrderError = createDispatchUpdate<string>(DispatchActionType.ORDER_SET_ERROR_MESSAGE);

// ============================== Store Selectors =================================
export const PeachPayOrder = {
	sessionId: () => store.getState().peachPayOrder.sessionId,
	contents: () => store.getState().calculatedCarts[0].cart,
	errorMessage: () => store.getState().peachPayOrder.errorMessage,
	collectSelectedShipping() {
		const carts = store.getState().calculatedCarts;
		const selectedShippingMethodsRecord: Record<string, string> = {};

		for (const cartKey of Object.keys(carts)) {
			const cart = carts[cartKey];

			if (!cart) {
				continue;
			}

			for (const packageKey of Object.keys(cart.package_record ?? {})) {
				const packageRecord = cart.package_record[packageKey];

				if (!packageRecord) {
					continue;
				}

				selectedShippingMethodsRecord[packageKey] = packageRecord.selected_method;
			}
		}

		return selectedShippingMethodsRecord;
	},
	orderFormRecord() {
		const {fieldData, fieldOrder} = GLOBAL.phpData ? addOrderNotesToAdditionalFields(GLOBAL.phpData) : {fieldData: [], fieldOrder: []};
		const formInfoRecord: Record<string, string> = {
			...PeachPayCustomer.data().form_fields,
			...PeachPayCustomer.wcBillingAddress(),
			...PeachPayCustomer.wcShippingAddress(),
			...collectAdditionalFieldData(fieldData, fieldOrder),
		} as Record<string, string>;
		cleanFormFields(formInfoRecord);
		formInfoRecord['ship_to_different_address'] = PeachPayCustomer.shipToDifferentAddress() ? '1' : '0';
		for (const [packageKey, selectedOption] of Object.entries(PeachPayOrder.collectSelectedShipping())) {
			formInfoRecord[`shipping_method[${packageKey}]`] = selectedOption;
		}

		return formInfoRecord;
	},
	customerAddressValidated: () => store.getState().peachPayOrder.customerAddressValidated,
	extraFieldsRecord: () => store.getState().peachPayOrder.additionalFields,
};
